// extracted by mini-css-extract-plugin
module.exports = {"skeleton":"SkeletonLoaderForHeading_skeleton__1pQ-y","loading":"SkeletonLoaderForHeading_loading__14IUN","h4_skeleton":"SkeletonLoaderForHeading_h4_skeleton__3VVIm"};